import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getEnvRuntimeVariable } from '@if/core/utils';
import { useTranslation } from 'react-i18next';
// Maintenance window is configured via ARM/env variables. Values must be ISO 8601
// strings with an explicit offset (e.g. "2026-05-16T06:45:00-04:00"). DST is the
// responsibility of whoever sets the variable.
const parseEnvDate = (raw) => {
    if (typeof raw !== 'string' || raw.length === 0)
        return undefined;
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? undefined : d;
};
export const FLINKS_MAINTENANCE_WINDOW = {
    start: parseEnvDate(getEnvRuntimeVariable(import.meta.env.VITE_FLINKS_MAINTENANCE_START)),
    end: parseEnvDate(getEnvRuntimeVariable(import.meta.env.VITE_FLINKS_MAINTENANCE_END)),
};
export const isWithinFlinksMaintenanceWindow = (now = new Date(), start = FLINKS_MAINTENANCE_WINDOW.start, end = FLINKS_MAINTENANCE_WINDOW.end) => start !== undefined && end !== undefined && now >= start && now < end;
export const FlinksMaintenancePage = ({ startDate = FLINKS_MAINTENANCE_WINDOW.start, endDate = FLINKS_MAINTENANCE_WINDOW.end, }) => {
    const { t, i18n } = useTranslation('shared');
    const locale = i18n.language === 'fr' ? 'fr-CA' : 'en-CA';
    const dateLabel = startDate?.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    const timeFmt = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    };
    const startTime = startDate?.toLocaleTimeString(locale, timeFmt);
    const endTime = endDate?.toLocaleTimeString(locale, timeFmt);
    return (_jsxs("main", { id: "flinks-maintenance", className: "general-message", children: [_jsx("h1", { style: { textAlign: 'center' }, children: t('flinksMaintenance.title') }), _jsx("div", { style: { display: 'flex', justifyContent: 'center', width: '100%' }, children: _jsx("h3", { className: "subtitle", children: t('flinksMaintenance.subtitle') }) }), _jsx("p", { className: "paragraph", children: t('flinksMaintenance.description') }), dateLabel && startTime && endTime && (_jsx("p", { className: "paragraph", children: _jsx("strong", { children: t('flinksMaintenance.window', { date: dateLabel, startTime, endTime }) }) })), _jsx("p", { className: "paragraph", children: t('flinksMaintenance.tryAgainLater') })] }));
};
export const FlinksMaintenanceGate = ({ children, startDate, endDate }) => {
    if (isWithinFlinksMaintenanceWindow(new Date(), startDate, endDate)) {
        return _jsx(FlinksMaintenancePage, { startDate: startDate, endDate: endDate });
    }
    return _jsx(_Fragment, { children: children });
};
export default FlinksMaintenancePage;
